export default __webpack_public_path__ + "static/media/streamer_avatar10.55a40a70.png";